import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function noSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value !== null && typeof control.value === 'string') {
      const isWhitespace = control.value.trim().length === 0
      return isWhitespace ? { noSpaces: true } : null
    }

    return null
  }
}